import { useHistory, useParams } from 'react-router-dom';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';
import WALLBOARD_IMAGE from 'images/wallboard/wallboard_example.png';

const DashboardIntro = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();

    return (
        <div className="flex flex-col items-center justify-center gap-9">
            <img src={WALLBOARD_IMAGE} alt={i18next.t('settings.dashboards')} />

            <div className="flex max-w-md flex-col justify-center gap-6 text-center">
                <h2 className="text-2xl font-bold">
                    {i18next.t('settings.dashboards.intro.title')}
                </h2>
                <p>{i18next.t('settings.dashboards.intro.body')}</p>
            </div>

            <Button
                color="primary"
                onClick={() =>
                    history.push(
                        generatePath(
                            routes[
                                'settings.dashboards.create.templates-picker'
                            ],
                            { extensionKey },
                        ),
                    )
                }
                className="px-5 py-3"
            >
                {i18next.t('wallboard.create_a')}
            </Button>
        </div>
    );
};

export default DashboardIntro;
